'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

import createQueryClient from './createQueryClient';

/**
 * app router 용 QueryClient 공급자.
 *
 * pages router 의 QueryProvider 는 AppProps['pageProps'] 를 받아 Hydrate 까지 하는데,
 * app router 에는 pageProps 가 없고 서버 컴포넌트가 데이터를 props 로 내려주므로
 * dehydratedState 없이 client 만 제공한다.
 *
 * 이게 없으면 useQuery 를 부르는 화면이 "No QueryClient set" 으로 죽는다
 * (reply_status 가 켜진 게시판의 댓글 등).
 */
export default function AppQueryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
